import { useState, useEffect, useCallback } from 'react';
import { fetchRecentParcels, type RecentParcel } from '../services/api';

export function useRecentParcels(limit = 10) {
  const [parcels, setParcels] = useState<RecentParcel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchRecentParcels(limit);
      setParcels(data.parcels);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load recent parcels');
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    load();
  }, [load]);

  return { parcels, loading, error, refresh: load };
}
